import { motion } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { useLeadDialog } from "@/components/site/LeadDialog";
import { CONTACT } from "@/lib/constants";

export default function FinalCTA() {
  const { openPreview } = useLeadDialog();
  return (
    <section id="contact" data-testid="final-cta-section" className="relative bg-[color:var(--ww-cream)] pt-16 pb-20 md:pb-28 noise overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[80vw] h-[60vh] bg-gradient-to-br from-emerald-300/25 to-teal-400/10 blur-[140px] rounded-full" />
      </div>
      <div className="relative max-w-[92rem] mx-auto px-5 md:px-10">
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-bold uppercase text-[clamp(3rem,12vw,13rem)] leading-[0.9] tracking-tight text-[color:var(--ww-charcoal)]">
          Your business<br /><span className="text-brand-gradient">could be next.</span>
        </motion.h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-end">
          <p className="md:col-span-6 lg:col-span-5 text-lg text-black/60 leading-relaxed max-w-lg font-body">
            See what your new website could look like, before you pay anything. Personalised, on-brand, tailored to your services.
          </p>
          <div className="md:col-span-6 lg:col-span-6 lg:col-start-7 flex flex-col sm:flex-row gap-3 sm:justify-end">
            <button type="button" onClick={() => openPreview()} data-testid="final-cta-preview"
              className="group inline-flex items-center gap-3 pl-5 pr-2 py-2 rounded-full bg-[color:var(--ww-charcoal)] text-white text-sm font-semibold hover:bg-black transition-colors font-body">
              Get Your Free Website Preview
              <span className="inline-grid place-items-center w-10 h-10 rounded-full bg-gradient-to-br from-teal-400 to-emerald-500 text-black">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </button>
            <a href={`tel:${CONTACT.phoneRaw}`} data-testid="final-cta-call-link"
              className="inline-flex items-center gap-2 text-sm text-black/70 hover:text-black self-center font-body">
              <Phone className="w-4 h-4" />{CONTACT.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
